/**
 * @generated SignedSource<<0fdef26b1daae655eda1e53c857491ff>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type Chain = "Arbitrum" | "Ethereum" | "Optimism" | "POAP" | "Polygon" | "Tezos" | "%future added value";
export type AuthMechanism = {
  debug?: DebugAuth | null;
  eoa?: EoaAuth | null;
  gnosisSafe?: GnosisSafeAuth | null;
};
export type EoaAuth = {
  chainPubKey: ChainPubKeyInput;
  nonce: string;
  signature: string;
};
export type ChainPubKeyInput = {
  chain: Chain;
  pubKey: any;
};
export type GnosisSafeAuth = {
  address: string;
  nonce: string;
};
export type DebugAuth = {
  asUsername?: string | null;
  chainAddresses?: ReadonlyArray<ChainAddressInput> | null;
  userId?: string | null;
};
export type ChainAddressInput = {
  address: string;
  chain: Chain;
};
export type useDebugAuthLoginMutation$variables = {
  mechanism: AuthMechanism;
};
export type useDebugAuthLoginMutation$data = {
  readonly login: {
    readonly __typename: "ErrAuthenticationFailed";
    readonly message: string;
  } | {
    readonly __typename: "ErrDoesNotOwnRequiredToken";
    readonly message: string;
  } | {
    readonly __typename: "ErrUserNotFound";
    readonly message: string;
  } | {
    readonly __typename: "LoginPayload";
    readonly userId: string;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
};
export type useDebugAuthLoginMutation = {
  response: useDebugAuthLoginMutation$data;
  variables: useDebugAuthLoginMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "mechanism"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "authMechanism",
    "variableName": "mechanism"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userId",
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "message",
    "storageKey": null
  }
],
v5 = {
  "kind": "InlineFragment",
  "selections": (v4/*: any*/),
  "type": "ErrUserNotFound",
  "abstractKey": null
},
v6 = {
  "kind": "InlineFragment",
  "selections": (v4/*: any*/),
  "type": "ErrAuthenticationFailed",
  "abstractKey": null
},
v7 = {
  "kind": "InlineFragment",
  "selections": (v4/*: any*/),
  "type": "ErrDoesNotOwnRequiredToken",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useDebugAuthLoginMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "login",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "RequiredField",
                "field": (v3/*: any*/),
                "action": "THROW",
                "path": "login.userId"
              }
            ],
            "type": "LoginPayload",
            "abstractKey": null
          },
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useDebugAuthLoginMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "login",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/)
            ],
            "type": "LoginPayload",
            "abstractKey": null
          },
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f9412f5243bd4f87b07a46c99f849407",
    "id": null,
    "metadata": {},
    "name": "useDebugAuthLoginMutation",
    "operationKind": "mutation",
    "text": "mutation useDebugAuthLoginMutation(\n  $mechanism: AuthMechanism!\n) {\n  login(authMechanism: $mechanism) {\n    __typename\n    ... on LoginPayload {\n      userId\n    }\n    ... on ErrUserNotFound {\n      message\n    }\n    ... on ErrAuthenticationFailed {\n      message\n    }\n    ... on ErrDoesNotOwnRequiredToken {\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "64ec8885532dba027ee0e55c3b959180";

export default node;
